import React, { Component, useEffect } from 'react';

import HandshqApp from 'handshq-app/handshq-app';
import PropTypes from 'prop-types';

import useToasts from 'components/hooks/useToasts';

import ToastRack from 'components/application/ToastRack';

import GlobalToast from 'components/toastMessages/GlobalToast';

class GlobalToastRackAPI extends Component {
  // eslint-disable-next-line react/no-unused-class-component-methods
  addInedibleToast = (options) => {
    this.props.addInedibleToast(options);
  };

  render() {
    return <ToastRack toasts={this.props.toasts} />;
  }
}

export default function GlobalToastRack({ messages = [] }) {
  const [toasts, , addToast, handleBurnToast, addInedibleToast] = useToasts();

  useEffect(() => {
    if (messages && messages.length > 0) {
      messages.forEach((message) => {
        addToast(
          <GlobalToast
            messageProps={message.data}
            messageType={message.type}
            onBurnToast={handleBurnToast}
          />,
        );
      });
    }
  }, []);

  return (
    <GlobalToastRackAPI
      addInedibleToast={addInedibleToast}
      ref={(node) => {
        HandshqApp.GlobalToastRackAPI = node;
      }}
      toasts={toasts}
    />
  );
}

GlobalToastRack.propTypes = {
  messages: PropTypes.array,
};
